export default "__VITE_ASSET__BxvBkIUL__"